import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import moment from 'moment-timezone'

import { simpleHtmlFormat } from 'Utilities/StringManipulator'
import LoadingSpinner from 'Components/LoadingSpinner'

const HistoryItem = ({ logItem, historyIcon }) => (
  <div className="correspondence">
    <div className="correspondence__header">
      <p className="correspondence__header--text">
        <span className={`${historyIcon} correspondence__header--icon`} />
        {`${logItem.title}, on ${moment(logItem.created_at).format('DD MMMM YYYY, hh:mmA')}`}
      </p>
    </div>
    <div className={`correspondence__content correspondence__content--support ${logItem.is_internal && "correspondence__content--internal"}`}>
      <div className="correspondence__content--text">
        {simpleHtmlFormat(logItem.content)}
      </div>
    </div>
  </div>
)

HistoryItem.propTypes = {
  logItem: PropTypes.shape({
    title: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired
  }).isRequired,
  historyIcon: PropTypes.string
}

HistoryItem.defaultProps = {
  historyIcon: ''
}

const History = ({ history, loading }) => {
  if (loading) {
    return <LoadingSpinner />
  }

  const historyIcon = ({ title }) => {
    if (_.startsWith(title, 'Email')) { return 'lnr lnr-inbox2' }
    if (_.startsWith(title, 'Call')) { return 'lnr lnr-telephone' }
    if (_.startsWith(title, 'Internal Note')) { return 'lnr lnr-document' }

    return ''
  }

  const historyItems = _.map(history, (historyItem, index) => (<HistoryItem key={index} logItem={historyItem} historyIcon={historyIcon(historyItem)} />))
  const blankHistory = { title: '', content: 'There is no history.' }

  return (
    <div>
      {history && historyItems}
      {_.isEmpty(history) && <HistoryItem logItem={blankHistory} />}
    </div>
  )
}

History.propTypes = {
  history: PropTypes.arrayOf(PropTypes.object).isRequired,
  loading: PropTypes.bool
}

History.defaultProps = {
  loading: false
}

export default History
